import {
  Component,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ExtranetAuthenticationService } from '@core/services/extranet-authentication.service';
import { ExtranetMenuService } from '@core/services/extranet-menu.service';
import { PasswordService } from '@core/services/password.service';
import { environment } from '@env';
import { IceMenuItem } from '@src/app/core/models/ice-menu-item.model';
import { SideMenuItem } from '@src/app/core/models/side-menu-item.model';
import { TodoListCountResponse } from '@src/app/core/models/todo-list-count-response.model';
import { ElementControlService } from '@src/app/core/services/element-control.service';
import { NewsService } from '@src/app/core/services/news.service';
import { RecaptchaComponent } from 'ng-recaptcha';
import { SelectItem } from 'primeng/api';
import { Subject, combineLatest } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import {
  AuthenticationService,
  BaseComponent,
  Configuration,
  StorageService,
  UserProfileService,
} from 'sigv-library';
import { deepCopy, isNullOrEmpty } from 'sigv-library/util';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @ViewChild(RecaptchaComponent) recaptcha?: RecaptchaComponent;

  isMenuVisible$ = this.extranetMenuService.getSideMenuObservable();

  isWindowOpen: boolean = window.location.search.includes('isWindowOpen=true');

  userNoAndName = '';

  locale = '';
  currentLanguageLabel = '';
  languageOptions: SelectItem[] = [];

  currentPassword = '';
  newPassword = '';
  confirmPassword = '';
  recaptchaToken = '';

  currentSubMenu = '';

  hasPermissionMenus: SideMenuItem[] = [];
  menuItemSettings: SideMenuItem[] = [
    {
      systemCode: 'Web Submission',
      functionCode: 'Submission',
      privilegeCode: 'Add',
      icon: 'ic-m-add-white.svg',
      label: 'Submission',
      routerLinkPath: '/submission',
      isHighlight: true,
      translateKey: 'Menu.Submission',
    },
    {
      icon: 'ic-todo.svg',
      label: 'Todo', // 程式邏輯、畫面都有用此值做判斷，修改時需注意
      eventCount: 0,
      translateKey: 'Menu.To Do',
      subMenus: [
        {
          icon: 'ic-draft.svg',
          label: 'Draft',
          routerLinkPath: '/todo/draft-list',
          eventCountKey: 'draftCount',
          translateKey: 'Menu.Draft',
        },
        {
          icon: 'ic-reject.svg',
          label: 'Returned/Pending Additional Doc',
          eventCountKey: 'returnedCount',
          routerLinkPath: '/todo/returned-pending-additional-doc',
          translateKey: 'Menu.Returned/Pending Additional Doc',
        },
        {
          icon: 'ic-wait.svg',
          label: 'Pending Commencement Doc',
          eventCountKey: 'pendingCommencementDocCount',
          routerLinkPath: 'todo/pending-commencement-doc-list',
          translateKey: 'Menu.Pending Commencement Doc',
        },
        {
          icon: 'ic-lou.svg',
          label: 'Download the LOU',
          eventCountKey: 'downloadtheLOUCount',
          routerLinkPath: '/todo/download-lou?action=list',
          translateKey: 'Menu.Download Approval Document', // 下載核准書不同國家顯示的英文不同，需依國別(專案)調整語系設定
        },
        {
          icon: 'ic-apply.svg',
          label: 'Prepared Agreement Apply',
          eventCountKey: 'agreementPrepApplyCount',
          routerLinkPath: '/todo/agreement-prep-list',
          translateKey: 'Menu.Prepared Agreement Apply',
        },
        {
          icon: 'ic-apply.svg',
          label: 'Prepared Agreement Todo',
          eventCountKey: 'agreementPrepTodoCount',
          routerLinkPath: '/todo/agreement-prep-todo-list',
          translateKey: 'Menu.Prepared Agreement Todo',
        },
        {
          icon: 'ic-apply.svg',
          label: 'Sign Delivery Order',
          eventCountKey: 'signDeliveryOrderTodoCount',
          routerLinkPath: '/todo/sign-delivery-order-list',
          translateKey: 'Menu.Sign Delivery Order',
        },
        {
          icon: 'ic-deal.svg',
          label: 'Download Agreement',
          eventCountKey: 'downloadAgreementCount',
          routerLinkPath: '/todo/download-agreement-list',
          translateKey: 'Menu.Download Agreement',
        },
        {
          icon: 'ic-eh-apply.svg',
          label: 'E-HAKMILIK Apply',
          eventCountKey: 'ehakmilikApplyCount',
          routerLinkPath: '/todo/ehakmilik-apply-list',
          translateKey: 'Menu.E-HAKMILIK Apply',
        },
        {
          icon: 'ic-file-down.svg',
          label: 'E-HAKMILIK Download',
          eventCountKey: 'ehakmilikDownloadCount',
          routerLinkPath: '/todo/ehakmilik-download-list',
          translateKey: 'Menu.E-HAKMILIK Download',
        },
        {
          icon: 'ic-hammer.svg',
          label: 'Commencement Documents Upload',
          eventCountKey: 'commencementDocUploadCount',
          routerLinkPath: '/todo/commencement-doc-upload-list',
          translateKey: 'Menu.Commencement Documents Upload',
        },
        {
          icon: 'ic-draft.svg',
          label: 'Submission Field Setting Draft',
          routerLinkPath: '/todo/list?status=Draft',
          eventCountKey: 'fieldSettingDraftCount',
          translateKey: 'Menu.Submission Field Setting Draft',
        },
        {
          icon: 'ic-hammer.svg',
          label: 'Submission Field Setting Apply',
          routerLinkPath: '/todo/list?status=Return',
          eventCountKey: 'fieldSettingApplyCount',
          translateKey: 'Menu.Submission Field Setting Apply',
        },
        {
          icon: 'ic-hammer.svg',
          label: 'Submission Field Setting Approve',
          routerLinkPath: '/todo/list?status=Processing',
          eventCountKey: 'fieldSettingApproveCount',
          translateKey: 'Menu.Submission Field Setting Approve',
        },
        {
          icon: 'ic-hammer.svg',
          label: 'Submission Field Setting Withdraw Approve',
          routerLinkPath: '/todo/list?status=WithdrawApproving',
          eventCountKey: 'fieldSettingWithdrawReviewCount',
          translateKey: 'Menu.Submission Field Setting Withdraw Approve',
        },
        {
          icon: 'ic-draft.svg',
          label: 'Announcement Setting Draft',
          eventCountKey: 'announcememtDraftCount',
          routerLinkPath: '/todo/announcement-setting/draft',
          translateKey: 'Menu.Announcement Setting Draft',
        },
        {
          icon: 'ic-anno-apply.svg',
          label: 'Announcement Setting Apply',
          eventCountKey: 'announcememtApplyCount',
          routerLinkPath: '/todo/announcement-setting/apply',
          translateKey: 'Menu.Announcement Setting Apply',
        },
        {
          icon: 'ic-anno-approve.svg',
          label: 'Announcement Setting Approve',
          eventCountKey: 'announcementApproveCount',
          routerLinkPath: '/todo/announcement-setting/approve',
          translateKey: 'Menu.Announcement Setting Approve',
        },
      ],
    },
    {
      systemCode: 'Web Submission',
      functionCode: 'Search',
      privilegeCode: 'Search',
      icon: 'ic-view.svg',
      label: 'Search',
      routerLinkPath: '/search',
      translateKey: 'Menu.Search',
    },
    {
      systemCode: 'Web Submission',
      functionCode: 'CaseManagement',
      privilegeCode: 'CaseManagement',
      icon: 'ic-view.svg',
      label: 'Case Management',
      translateKey: 'Menu.CaseManagement',
      subMenus: [
        {
          systemCode: 'Web Submission',
          functionCode: 'CaseManagement',
          privilegeCode: 'Funding Exp',
          icon: 'ic-view.svg',
          label: 'Commencement Plan',
          routerLinkPath: '/funding-exp',
          translateKey: 'Menu.FundingExp',
        },
        {
          systemCode: 'Web Submission',
          functionCode: 'CaseManagement',
          privilegeCode: 'SalesQuote',
          icon: 'ic-view.svg',
          label: 'Sales Quote',
          routerLinkPath: '/sales-quote',
          translateKey: 'Menu.SalesQuote',
        },
      ],
    },
    
    {
      systemCode: 'Web Submission',
      functionCode: 'Report',
      privilegeCode: 'Report',
      icon: 'ic-report.svg',
      label: 'Report',
      translateKey: 'Menu.Report',
      subMenus: [
        {
          systemCode: 'Web Submission',
          functionCode: 'Report',
          privilegeCode: 'Approval',
          icon: 'ic-report.svg',
          label: 'Approval',
          routerLinkPath: '/report/approval',
          translateKey: 'Menu.Approval',
        },
        {
          systemCode: 'Web Submission',
          functionCode: 'Report',
          privilegeCode: 'SalesTargetCompletionBriefing',
          icon: 'ic-report.svg',
          label: 'Sales Target Completion Briefing',
          routerLinkPath: '/report/sales-target-completion-briefing',
          translateKey: 'Menu.SalesTargetCompletionBriefing',
          onlyUseRole: 0,
        },
        {
          systemCode: 'Web Submission',
          functionCode: 'Report',
          privilegeCode: 'SalesPerformanceReport',
          icon: 'ic-report.svg',
          label: 'Sales Performance Report',
          routerLinkPath: '/report/sales-performance-report',
          translateKey: 'Menu.SalesPerformanceReport',
          onlyUseRole: 0,
        },
        {
          systemCode: 'Web Submission',
          functionCode: 'Report',
          privilegeCode: 'GrowthAnalysis',
          icon: 'ic-report.svg',
          label: 'Growth Analysis',
          routerLinkPath: '/report/growth-analysis',
          translateKey: 'Menu.GrowthAnalysis',
          onlyUseRole: 0,
        },
        {
          systemCode: 'Web Submission',
          functionCode: 'Report',
          privilegeCode: 'PerformanceTrends',
          icon: 'ic-report.svg',
          label: 'Performance Trends',
          routerLinkPath: '/report/performance-trends',
          translateKey: 'Menu.PerformanceTrends',
          onlyUseRole: 0,
        },
      ],
    },
    {
      systemCode: 'Web Submission',
      functionCode: 'Insurance',
      privilegeCode: 'Insurance',
      eventCount: 0,
      eventCountKey: 'insuranceCount',
      icon: 'ic-insurance.svg',
      label: 'Insurance', // 程式邏輯、畫面都有用此值做判斷，修改時需注意
      routerLinkPath: '/insurance/list',
      translateKey: 'Menu.Insurance',
    },
    {
      systemCode: 'Web Submission',
      functionCode: 'Announcement',
      privilegeCode: 'Enquire',
      icon: 'ic-announcement.svg',
      label: 'Announcement',
      routerLinkPath: '/announcement/list',
      translateKey: 'Menu.Announcement',
    },
    {
      systemCode: 'Web Submission',
      functionCode: 'WebSubmissionSetting',
      privilegeCode: 'Enquire',
      icon: 'ic-setup.svg',
      label: 'Submission Field Setting',
      routerLinkPath: '/setting',
      translateKey: 'Menu.Submission Field Setting',
    },
    {
      systemCode: 'Web Submission',
      functionCode: 'AnnouncementSetting',
      privilegeCode: 'Enquire',
      icon: 'ic-announcement-setting.svg',
      label: 'Announcement Setting',
      eventCount: 0,
      translateKey: 'Menu.Announcement Setting',
      subMenus: [
        {
          systemCode: 'Web Submission',
          functionCode: 'AnnouncementSetting',
          privilegeCode: 'Add',
          icon: 'ic-anno-add.svg',
          label: 'Add Announcement',
          routerLinkPath: '/announcement/draft',
          translateKey: 'Menu.Add Announcement',
        },
        {
          systemCode: 'Web Submission',
          functionCode: 'AnnouncementSetting',
          privilegeCode: 'Edit',
          icon: 'ic-anno-edit.svg',
          label: 'Edit Announcement',
          routerLinkPath: '/announcement/edit/query',
          translateKey: 'Menu.Edit Announcement',
        },
        {
          systemCode: 'Web Submission',
          functionCode: 'AnnouncementSetting',
          privilegeCode: 'Enquire',
          icon: 'ic-anno-query.svg',
          label: 'Query Announcement',
          routerLinkPath: '/announcement/general/query',
          translateKey: 'Menu.Query Announcement',
        },
      ],
    },
  ];
  permissionMenus: IceMenuItem[] = [];
  useRole?: number;
  //是否顯示google驗證圖形
  elementControlJSON = {
    Login: {
      GoogleReCaptcha: {
        display: false,
      },
    },
  };
  private readonly destroy$ = new Subject();

  constructor(
    protected injector: Injector,
    private userProfileService: UserProfileService,
    private extranetMenuService: ExtranetMenuService,
    private passwordService: PasswordService,
    private authenticationService: AuthenticationService,
    private extranetAuthenticationService: ExtranetAuthenticationService,
    private configuration: Configuration,
    private router: Router,
    private storageService: StorageService,
    private newsService: NewsService,
    private elementControlService: ElementControlService
  ) {
    super(injector);
    this.languageOptions = this.appConfig.languageList.map((x) => ({
      label: x.name,
      value: x.value,
    }));
    this.locale = this.storageService.lang.getItem() || 'en';
    this.currentLanguageLabel =
      this.languageOptions.find((item) => item.value === this.locale)?.label ||
      'English';
  }

  ngOnInit(): void {
    //取得是否顯示google驗證圖形
    this.elementControlService
      .getElementControl()
      .pipe(takeUntil(this.destroy$))
      .subscribe((elementControlJSON) => {
        if (isNullOrEmpty(elementControlJSON) === false) {
          this.elementControlJSON = elementControlJSON;
        }
      });

    this.userProfileService.currentUser
      .pipe(takeUntil(this.destroy$))
      .subscribe((currentUser) => {
        if (currentUser) {
          this.userNoAndName = `${currentUser.userNo} ${currentUser.userName}`;
        }
      });

    this.useRole = this.userProfileService.currentUserValue?.extranetUserRole;
    this.extranetMenuService.updateTodoListCount();
    this.newsService.updateNotification.next();

    combineLatest([
      this.extranetMenuService.getMenuItemsObservable(),
      this.extranetMenuService.getTodoListCountObservable(),
    ])
      .pipe(
        filter(([menus, todoListCount]) => {
          return (menus &&
            todoListCount &&
            Object.keys(todoListCount).length > 0) as boolean;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(([menus, todoListCount]) => {
        // 清空選單內容，確保資料已初始化
        this.hasPermissionMenus = [];
        this.permissionMenus = menus;

        if (menus && menus.length > 0) {
          // 與使用者選單資料比對，具有權限之功能才加入選單
          this.menuItemSettings.forEach((item) => {

            var subItems :SideMenuItem[]=[];
            item.subMenus?.forEach((subItem)=>{

              if (
                this.isUserPermissionMenuItem(
                  subItem.systemCode,
                  subItem.functionCode,
                  subItem.privilegeCode
                )
              ) {
                const copyItem = deepCopy(subItem);
                if (copyItem) {
                  subItems.push(copyItem);
                }
              }
            });


            if (subItems.length > 0 ||
              this.isUserPermissionMenuItem(
                item.systemCode,
                item.functionCode,
                item.privilegeCode
              )
            ) {
              const copyItem = deepCopy(item);
              if (copyItem) {
                copyItem.subMenus = subItems;
                this.hasPermissionMenus.push(copyItem);
              }
            }
          });

          // 待辦選單項目應取得未處理筆數資料,目前使用 label 值做為判斷
          if (
            this.hasPermissionMenus.some((item) => item.label === 'Todo') ||
            this.hasPermissionMenus.some((item) => item.label === 'Insurance')
          ) {
            const targetMenutItem = this.hasPermissionMenus.find(
              (item) => item.label === 'Todo'
            );

            if (
              targetMenutItem?.subMenus &&
              targetMenutItem.subMenus.length > 0
            ) {
              const keys = Object.keys(
                todoListCount!
              ) as (keyof TodoListCountResponse)[];

              targetMenutItem.subMenus.forEach((subMenuItem) => {
                if (subMenuItem.eventCountKey) {
                  keys.forEach((key) => {
                    if (key === subMenuItem.eventCountKey) {
                      subMenuItem.eventCount = todoListCount![key];
                    }
                  });
                }
              });
              // 子選單大於 0 的項目才顯示
              targetMenutItem.subMenus = targetMenutItem.subMenus.filter(
                (item) => item.eventCount && item.eventCount > 0
              );

              // 合計子項的筆數
              targetMenutItem.eventCount = targetMenutItem.subMenus.reduce(
                (acc, item) => {
                  if (item.eventCount) {
                    acc = acc + item.eventCount;
                  }
                  return acc;
                },
                0
              );
            }
            const targetMenuItem = this.hasPermissionMenus.find(
              (item) => item.label === 'Insurance'
            );
            if (
              targetMenuItem &&
              targetMenuItem.eventCountKey &&
              todoListCount
            ) {
              targetMenuItem.eventCount =
                (todoListCount as any)[targetMenuItem.eventCountKey] || 0;
            }
          }
        } else {
          // 取出不需權限即可使用的選單項目,暫時先移除子選單的項目，必免沒有權限登入者出現待辦事項子選單
          let mainMenu =
            deepCopy(
              this.menuItemSettings.filter(
                (item) => !item.functionCode && !item.privilegeCode
              )
            ) || [];
          let finalMenu = mainMenu.map((targetMenutItem) => {
            if (
              targetMenutItem?.subMenus &&
              targetMenutItem.subMenus.length > 0
            ) {
              const keys = Object.keys(
                todoListCount!
              ) as (keyof TodoListCountResponse)[];

              targetMenutItem.subMenus.forEach((subMenuItem) => {
                if (subMenuItem.eventCountKey) {
                  keys.forEach((key) => {
                    if (key === subMenuItem.eventCountKey) {
                      subMenuItem.eventCount = todoListCount![key];
                    }
                  });
                }
              });
              // 子選單大於 0 的項目才顯示
              targetMenutItem.subMenus = targetMenutItem.subMenus.filter(
                (item) => item.eventCount && item.eventCount > 0
              );

              // 合計子項的筆數
              targetMenutItem.eventCount = targetMenutItem.subMenus.reduce(
                (acc, item) => {
                  if (item.eventCount) {
                    acc = acc + item.eventCount;
                  }
                  return acc;
                },
                0
              );
              return targetMenutItem;
            } else {
              return targetMenutItem;
            }
          });

          this.hasPermissionMenus = mainMenu;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isUserPermissionMenuItem(
    systemCode = '',
    functionCode = '',
    privilegeCode = ''
  ): boolean {
    // 未設定表示不需要特別權限，回傳 true
    if (!systemCode && !functionCode && !privilegeCode) {
      return true;
    } else {
      return this.permissionMenus.some(
        (item) =>
          item.systemCode === systemCode &&
          item.functionCode === functionCode &&
          item.privilegeCode === privilegeCode
      );
    }
  }

  goToPage(url: string | undefined): void {
    this.extranetMenuService.updateTodoListCount();
    this.newsService.updateNotification.next();

    if (url) {
      url === '/submission' && this.router.url === url
        ? window.location.reload()
        : this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigateByUrl(url));

      this.storageService.local.removeItem('web-submission');
      this.storageService.local.removeItem('leading-page-company');
    }
  }

  goToPageAndCloseMenu(url: string = ''): void {
    if (url) {
      this.router.navigateByUrl(url);
      this.currentSubMenu = '';
      this.extranetMenuService.toggleSideMenu();
    }
  }

  openSubMenu(targetSubMenu: string): void {
    if (targetSubMenu) {
      this.currentSubMenu = targetSubMenu;
    }
  }

  menuItemAction(menuItem: SideMenuItem): void {
    this.extranetMenuService.updateTodoListCount();
    this.newsService.updateNotification.next();

    if (menuItem.subMenus && menuItem.subMenus.length > 0) {
      this.openSubMenu(menuItem.label);
    } else {
      this.goToPageAndCloseMenu(menuItem.routerLinkPath);
    }
  }

  closeSubMenu(): void {
    this.currentSubMenu = '';
  }

  changeLanguage(event: any, languageOption: SelectItem): void {
    event.preventDefault();
    this.locale = languageOption.value;
    this.currentLanguageLabel = languageOption.label || '';
    this.translateService.use(this.locale);
    this.storageService.lang.setItem(this.locale);
    this.closeSubMenu();
  }

  errored(event: any): void {
    console.warn(`reCAPTCHA error encountered \n `, event);
  }

  clearChangePasswordForm(): void {
    this.newPassword = '';
    this.confirmPassword = '';
    this.recaptchaToken = '';
  }

  submitChangePassword(changePasswordForm: NgForm): void {
    if (changePasswordForm.valid) {
      this.passwordService
        .changePassword({
          account: this.userProfileService.currentUserValue?.userNo || '',
          currentPassword: this.passwordService.getEncryptedData(
            this.currentPassword
          ),
          newPassword: this.passwordService.getEncryptedData(this.newPassword),
          recaptchaToken: this.recaptchaToken,
        })
        .pipe(takeUntil(this.destroy$))
        .subscribe((isSuccess) => {
          if (isSuccess) {
            this.translateService
              .get('ForgotPassword.ChangePasswordSuccess')
              .subscribe((msg) => {
                this.toastService.success(msg);
                this.router.navigate(['/']);
                this.currentSubMenu = '';
                this.extranetMenuService.toggleSideMenu();
              });
          } else {
            this.translateService
              .get('ForgotPassword.ChangePasswordFail')
              .subscribe((msg) => {
                this.dialogService.showErrorDialog([
                  {
                    description: msg,
                  },
                ]);
              });
          }
          this.recaptcha?.reset();
          changePasswordForm.reset();
        });
    }
  }

  getBadgeStatusClassName(counter: number): string {
    if (counter < 10) {
      return 'low';
    } else if (counter >= 10 && counter < 20) {
      return 'medium';
    } else if (counter >= 20) {
      return 'high';
    }
    return '';
  }

  toggleSideMenu(): void {
    this.extranetMenuService.toggleSideMenu();
  }

  logout(): void {
    this.currentSubMenu = '';
    this.extranetMenuService.toggleSideMenu();
    if (environment.isExtranet) {
      this.router.navigate(['/logout']);
    } else {
      this.authenticationService.logout();
    }
    this.router.navigate([this.configuration.routePath.login]);
  }
}
